import styled from 'styled-components';
import LinkHandler from '../link-handler';
import { h3 } from '../styled/typography';

export const ItemLink = styled(LinkHandler)`
  color: ${({ theme, $activePage }) =>
    $activePage && theme.palette.standardText};
`;

export const Item = styled.p`
  font-weight: bold;
`;

export const UnorderedList = styled.ul`
  padding-left: ${({ theme }) => theme.spacing.medium};
  ${({ $depth, theme }) => {
    if ($depth > 0) {
      return `
        padding-left: ${theme.spacing.medium};
        border-left: 1px solid ${theme.palette.border};
      `;
    }

    return `
      padding-left: ${theme.spacing.standard};
    `;
  }}

  li > ul {
    margin-top: ${({ theme }) => theme.spacing.standard};
  }
`;

export const ListItem = styled.li`
  list-style: none;
`;

export const Heading = styled.h2`
  ${h3}
`;
